import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DataService } from './data.service';

export interface SsoStartResponse {
  authorizationUrl: string;
  accountId: number;
}

export interface SsoStatusResponse {
  accountId: number;
  verified: boolean;
}

@Injectable()
export class AccountAzureSsoService {
  constructor(private data: DataService) {}

  start(accountId: number): Observable<SsoStartResponse> {
    const returnUrl = `${window.location.origin}/accounts`;
    return this.data.post(`api/azure-sso/accounts/${accountId}/start`, { returnUrl });
  }

  status(accountId: number): Observable<SsoStatusResponse> {
    return this.data.get(`api/azure-sso/accounts/${accountId}/status`);
  }
}
